module.exports = __webpack_public_path__ + "static/media/design-lace-up.0669d75a.svg";